import { z } from 'zod';

export const accessRequestSchema = z.object({
  id: z.string(),
  user_code: z.string(),
  client_name: z.string(),
  created_at: z.string(),
  expires_at: z.string(),
});

export type AccessRequest = z.infer<typeof accessRequestSchema>;
